import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

type BadgeVariant = 'teal' | 'orange' | 'dark' | 'success';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  teal: 'bg-teal-100 text-teal-700',
  orange: 'bg-orange-100 text-orange-700',
  dark: 'bg-white/5 border border-white/10 text-slate-300',
  success: 'bg-emerald-50 text-emerald-600 border border-emerald-100',
};

export function Badge({ variant = 'teal', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
